module.exports = __webpack_public_path__ + "assets/img/652800.6d692517.png";